import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheMissingPerson(id) {
  const queryKey = ['nicheMissingPersons', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return platformApi.get(`niche/missing-persons/${id}`, { signal }).json();
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 60,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
